import { Button, Container } from '@mui/material';
import Result from 'components/Result';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { useRecoilValue } from 'recoil';
import { currentUser } from 'recoil/User';

// ----------------------------------------------------------------------

export default function RoleBasedGuard({ accessibleRoles, children }) {
  const user = useRecoilValue(currentUser);
  const navigate = useNavigate();
  if (!accessibleRoles.includes(user.role)) {
    return (
      <Container fixed>
        <Result
          status="403"
          title="Acceso Denegado"
          subTitle="Esta cuenta no tiene los suficientes permisos, si esto es un error porfavor contacte soporte."
          extra={
            <Button
              size="large"
              variant="outlined"
              onClick={() => navigate(-1)}
            >
              Entendido, volver
            </Button>
          }
        />
      </Container>
    );
  }

  return <>{children}</>;
}

RoleBasedGuard.propTypes = {
  accessibleRoles: PropTypes.array, // Example ['admin', 'leader']
  children: PropTypes.node
};
